<template>
  <div
    v-if="!noHeader"
    class="mx-auto relative xl:max-w-screen-xl lg:max-w-screen-lg md:max-w-screen-md mt-5 flex-auto"
  >
    <div
      v-if="userStore && userStore.id && !hideNavigation"
      class="block md:hidden mt-4 w-full"
    >
      <div
        v-if="navbarStore"
        class="flex space-x-4 lg:space-x-3 bg-bkk-50 rounded-full px-4 py-2 mx-auto mb-8 w-fit max-w-[310px]"
        role="navigation"
      >
        <NavLink
          v-for="item in navigation"
          :key="item.name"
          :icon="item.icon"
          :translation-key="item.name"
          :to="'/' + route.params.slug + item.href"
          :navbar-category="item.navbarCategory"
        />
      </div>
    </div>
    <div class="flex items-center justify-between h-16 mx-2">
      <div class="flex items-center w-60">
        <div class="flex-shrink-0">
          <div id="header_text"></div>
        </div>
      </div>
      <div
        v-if="userStore && userStore.id && !hideNavigation"
        class="hidden md:block max-w-7xl mt-4"
      >
        <div
          v-if="navbarStore"
          class="flex space-x-4 lg:space-x-3 bg-bkk-50 rounded-full px-4 py-2"
        >
          <NavLink
            v-for="item in navigation"
            :key="item.name"
            :icon="item.icon"
            :translation-key="item.name"
            :to="'/' + route.params.slug + item.href"
            :navbar-category="item.navbarCategory"
          />
        </div>
      </div>
    </div>
  </div>

  <DeleteSbkProfileModal
    :open="deleteSbkProfileModalOpen"
    @close="deleteSbkProfileModalOpen = false"
  />

  <DeleteProfileModal
    :open="deleteProfileModalOpen"
    @close="deleteProfileModalOpen = false"
  />

  <ChangePasswordModal
    :open="changePasswordModalOpen"
    @close="changePasswordModalOpen = false"
  />
</template>

<script lang="ts" setup>
import { ref, computed, onMounted } from "vue";
import NavLink from "./NavLink.vue";
import { useNavbarStore } from "../../../store/v2/navbar";
import { useUserStore } from "../../../store/v2/user";
import FeedIcon from "../icon/FeedIcon.vue";
import ChallengesIcon from "../icon/ChallengesIcon.vue";
import SettingsIcon from "../icon/SettingsIcon.vue";
import { useRoute, useRouter } from "vue-router";
import ChangePasswordModal from "../settings/ChangePasswordModal.vue";
import DeleteProfileModal from "../settings/DeleteProfileModal.vue";
import DeleteSbkProfileModal from "../sbk/DeleteSbkProfileModal.vue";

const navbarStore = ref();
const userStore = ref();
const changePasswordModalOpen = ref(false);
const deleteSbkProfileModalOpen = ref(false);
const deleteProfileModalOpen = ref(false);

const route = useRoute();

const navigation = [
  {
    name: "feed.tab.label",
    href: "/feed",
    icon: FeedIcon,
    navbarCategory: "feed",
  },
  {
    name: "challenges.tab.subtitle",
    href: "/challenges",
    icon: ChallengesIcon,
    navbarCategory: "challenges",
  },
  {
    name: "profile.screen.title.settings",
    href: "/settings",
    icon: SettingsIcon,
    navbarCategory: "settings",
  },
];

const hideNavigation = computed(() => route.meta.hideNavigation);
const noHeader = computed(() => route.meta.noHeader);

onMounted(() => {
  navbarStore.value = useNavbarStore();
  userStore.value = useUserStore();
});
</script>
